import React, { useEffect, useState } from 'react';

export default function PageQuestion01(props) {
  const [seconds_timer, setSecondsTimer] = useState(0);
  const [timeouts, setTimeouts] = useState([]);
  const [timestamp0, setTimestamp0] = useState(Date.now());
  const [timestamp1, setTimestamp1] = useState(undefined);

  const [res01, setRes01] = useState(undefined);
  const [stateQ, setStateQ] = useState(0);

  const questions = [
    "Describe what you see in the graph?",
    "What questions would you be able to answer from this graph?"
  ]
  const [questionText, setQuestionText] = useState(questions[0]);
  const [questionResponse, setQuestionResponse] = useState(undefined);


  const clearTimeouts = () => {
    timeouts.forEach(clearTimeout);
  }

  const increaseTimer = () => {
    setSecondsTimer(seconds_timer + 1);
    let tmpArr = timeouts
    tmpArr.push(setTimeout(increaseTimer.bind(this), 1000))
    setTimeouts(tmpArr)
  }

  const nextAction = () => {
    if(stateQ === 0){
      setStateQ(1)
      setQuestionText(questions[1])
      setRes01(questionResponse)
      setQuestionResponse("")
      setTimestamp1(Date.now())
    } else {
      let responses = {
        'id': props.viz_title,
        'res_desc': res01, 
        'res02_question': questionResponse,
        'timestamp0': timestamp0,
        'timestamp1': timestamp1,
        'timestamp2': Date.now(),
        'chart_type':props.viz.chart_type,
        'class_type':props.viz.class_type,
        'position_type':props.viz.position_type,
        'img_name':props.viz.img_name
      }

      setRes01(undefined)
      setStateQ(0)
      setQuestionText(questions[0])
      setQuestionResponse("")

      setTimestamp0(Date.now())
      setTimestamp1(undefined)
      setSecondsTimer(0)
      props.next(responses)
    }
  }


  useEffect(() => {
    let tmpArr = timeouts
    tmpArr.push(setTimeout(increaseTimer.bind(this), 1000))
    setTimeouts(tmpArr)

    return () => {
      clearTimeouts()
    };
  }, 
  	[clearTimeouts, increaseTimer]
  )

  return (
    <div>
      <h4 className='text-center'>Graph {props.pg_number} of {props.pg_total}</h4>

      <div className="row justify-content-md-center">
        <div className="col-10">
          <img className="img-fluid" src={"data:image/png;base64, "+props.viz.img_data} alt="visualization" />
        </div>
      </div>

      <br />

      <div>
        <h4>{questionText}</h4>
        <div className="form-group">
            <textarea className="form-control" value={questionResponse} onChange={(e) => setQuestionResponse(e.target.value)} rows="4" cols="50" placeholder="your response"/>
        </div>
        {}
      </div>

      <div className="text-center">
        <button 
          style={{ marginTop: '25px', width: '150px' }} 
          className="btn btn-outline-primary" 
          onClick={e => nextAction()}>Next</button>
      </div>
    </div>

  );
}
